import { createAuthClient } from "better-auth/client";

export const authClient = createAuthClient({});
